module.exports = __webpack_public_path__ + "static/media/ArialRoundedBold.98a0555d.woff";